import { SquareArrowOutUpRight, Trash } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { ProductImageFallback } from '@/components/ProductImageFallback';
import { Button } from '@/components/ui/Button';
import { ROUTE_PATHS } from '@/config/constants';
import { useGetProducts } from '@/hooks/useGetProducts';

interface PairsWithItemProps {
  pairsWith: string;
  onRemove: (productId: string) => void;
}

export function PairsWithItem({ pairsWith, onRemove }: PairsWithItemProps) {
  const [imageError, setImageError] = useState(false);

  const { products } = useGetProducts({ productId: pairsWith });

  if (products.length == 0) {
    return null;
  }

  const product = products[0];

  return (
    <div className="rounded-lg border border-solid border-[#E0E0E0]">
      <div className="group relative overflow-hidden">
        <div className="absolute left-0 top-0 h-full w-full bg-black opacity-0 group-hover:opacity-40" />

        {imageError ? (
          <ProductImageFallback />
        ) : (
          <img
            className="rounded-t-lg"
            src={product.image1}
            alt={product.name}
            onError={() => setImageError(true)}
          />
        )}

        <div className="absolute left-1/2 top-1/2 z-50 flex -translate-x-1/2 -translate-y-1/2 gap-2 opacity-0 transition-opacity group-hover:opacity-100">
          <Button type="button" size="icon" asChild>
            <Link
              to={ROUTE_PATHS.VISION_PRODUCT.replace(
                ':productId',
                String(product.id),
              )}
              target="_blank"
            >
              <SquareArrowOutUpRight className="h-4 w-4" />
            </Link>
          </Button>

          <Button
            type="button"
            variant="destructive"
            size="icon"
            onClick={() => onRemove(product.productId)}
          >
            <Trash className="h-4 w-4" />
          </Button>
        </div>
      </div>

      <div className="p-5 font-light">
        <span className="block truncate text-xs">{product.name}</span>
      </div>
    </div>
  );
}
